koUtil = require('resources/assets/coffee/Core/utils/knockout')

class exports.AddEditDialog extends KoModel

    constructor: (handler, data) ->
        super()

        @handler = handler
        @_orig_data = data

        @ignore [
            '_orig_data'
            'soil_type_max'
            'default_soils_low_yield_max'
            'default_soils_high_yield_min'
            'med_yield_min'
            'med_yield_max'
            'med_yield_min_irrigated'
            'med_yield_max_irrigated'
            'grower_yield_max'
            'grower_med_yield_min'
            'grower_med_yield_max'
            'grower_med_yield_min_irrigated'
            'grower_med_yield_max_irrigated'
        ]

        # @yield_units = ko.observable()

        @initSoilsRanges(data)
        @initGrowerRanges(data)


    initSoilsRanges: (data) =>
        @soil_type_max = ko.observable(500)
        @default_soils_low_yield_max = 99
        @default_soils_high_yield_min = 150

        # TODO: prefix variable names with "soils_"
        @low_yield_max = ko.observable(null)
        @med_yield_min = ko.observable(null)
        @med_yield_max = ko.observable(null)
        @high_yield_min = ko.observable(null)

        koUtil.linkValues(@low_yield_max, @med_yield_min)
        koUtil.linkValues(@med_yield_max, @high_yield_min)
        koUtil.constrainValues(0, @low_yield_max)
        koUtil.constrainValues(@med_yield_min, @med_yield_max)
        koUtil.constrainValues(@high_yield_min, @soil_type_max)

        @low_yield_max(data.zone?.low_yield_max ? @default_soils_low_yield_max)
        @high_yield_min(data.zone?.high_yield_min ? @default_soils_high_yield_min)

        if data.show_irrigated_columns
            @low_yield_max_irrigated = ko.observable(null)
            @med_yield_min_irrigated = ko.observable(null)
            @med_yield_max_irrigated = ko.observable(null)
            @high_yield_min_irrigated = ko.observable(null)

            koUtil.linkValues(@low_yield_max_irrigated, @med_yield_min_irrigated)
            koUtil.linkValues(@med_yield_max_irrigated, @high_yield_min_irrigated)
            koUtil.constrainValues(0, @low_yield_max_irrigated)
            koUtil.constrainValues(@med_yield_min_irrigated, @med_yield_max_irrigated)
            koUtil.constrainValues(@high_yield_min_irrigated, @soil_type_max)

            @low_yield_max_irrigated(data.zone?.low_yield_max_irrigated ? @default_soils_low_yield_max)
            @high_yield_min_irrigated(data.zone?.high_yield_min_irrigated ? @default_soils_high_yield_min)

    setSoilsDefaults: (low_yield_max, high_yield_min) =>
        # if the ranges are still at the old defaults, go ahead and update them
        if @low_yield_max() is @default_soils_low_yield_max and
                @high_yield_min() is @default_soils_high_yield_min
            @low_yield_max(low_yield_max)
            @high_yield_min(high_yield_min)

        if @_orig_data.show_irrigated_columns
            if @low_yield_max_irrigated() is @default_soils_low_yield_max and
                    @high_yield_min_irrigated() is @default_soils_high_yield_min
                @low_yield_max_irrigated(low_yield_max)
                @high_yield_min_irrigated(high_yield_min)

        # now set the defaults (to check against later)
        @default_soils_low_yield_max = low_yield_max
        @default_soils_high_yield_min = high_yield_min


    initGrowerRanges: (data) =>
        @grower_yield_max = ko.observable(data.grower_yield_max ? 500)

        @grower_low_yield_max = ko.observable(null)
        @grower_med_yield_min = ko.observable(null)
        @grower_med_yield_max = ko.observable(null)
        @grower_high_yield_min = ko.observable(null)

        koUtil.linkValues(@grower_low_yield_max, @grower_med_yield_min)
        koUtil.linkValues(@grower_med_yield_max, @grower_high_yield_min)
        koUtil.constrainValues(0, @grower_low_yield_max)
        koUtil.constrainValues(@grower_med_yield_min, @grower_med_yield_max)
        koUtil.constrainValues(@grower_high_yield_min, @grower_yield_max)

        @grower_low_yield_max(data.zone?.grower_low_yield_max ? data.default_grower_low_yield_max)
        @grower_high_yield_min(data.zone?.grower_high_yield_min ? data.default_grower_high_yield_min)

        if data.show_irrigated_columns
            @grower_low_yield_max_irrigated = ko.observable(null)
            @grower_med_yield_min_irrigated = ko.observable(null)
            @grower_med_yield_max_irrigated = ko.observable(null)
            @grower_high_yield_min_irrigated = ko.observable(null)

            koUtil.linkValues(@grower_low_yield_max_irrigated, @grower_med_yield_min_irrigated)
            koUtil.linkValues(@grower_med_yield_max_irrigated, @grower_high_yield_min_irrigated)
            koUtil.constrainValues(0, @grower_low_yield_max_irrigated)
            koUtil.constrainValues(@grower_med_yield_min_irrigated, @grower_med_yield_max_irrigated)
            koUtil.constrainValues(@grower_high_yield_min_irrigated, @grower_yield_max)

            @grower_low_yield_max_irrigated(data.zone?.grower_low_yield_max_irrigated ? data.default_grower_low_yield_max)
            @grower_high_yield_min_irrigated(data.zone?.grower_high_yield_min_irrigated ? data.default_grower_high_yield_min)


    getSoilTypeRange: (min_offset, max_offset) =>
        comp = ko.computed =>
            min = 0 + min_offset
            max = @soil_type_max() + max_offset # should be negative

            return [min..max]

        return comp

    getGrowerYieldRange: (min_offset, max_offset) =>
        comp = ko.computed =>
            min = 0 + min_offset
            max = @grower_yield_max() + max_offset # should be negative

            return [min..max]

        return comp
